import type { ImagingResultTemplateDocument } from '@type/imaging_results.type'
import DocTemplatePreviewView from './DocTemplate/DocTemplatePreviewView'
import type { DocTemplatePreviewDocument } from './DocTemplate/templateDefinition'

export interface ImagingResultDocumentPreviewProps {
  document: ImagingResultTemplateDocument
}

/** Read-only snapshot of a captured template (`imaging_result.attributes.document`). */
const ImagingResultDocumentPreview = ({ document: doc }: ImagingResultDocumentPreviewProps) => {
  const previewDoc: DocTemplatePreviewDocument = { ...doc, category: '' }

  return (
    <div className="imaging-result-document-preview flex max-h-[min(70vh,720px)] flex-1 flex-col overflow-y-auto pr-1 text-left print:max-h-none print:overflow-visible">
      <DocTemplatePreviewView document={previewDoc} variant="snapshot" />
    </div>
  )
}

export default ImagingResultDocumentPreview
